var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main_auth_page"},[_c('div',{staticClass:"auth_page_wrp"},[_c('slider'),_c('sign-up')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }